import { useViewHistory, ViewHistoryKey } from "@grandvisionhq/state";
const useProductViewHistory = useViewHistory.bind(null, ViewHistoryKey.Products);
export {
  useProductViewHistory
};
//# sourceMappingURL=use-product-view-history.js.map
